import * as React from 'react';
import { reduxForm, Field, SubmissionError } from 'redux-form';
/* import { debug } from '../../../utils';
 * const log = debug('lego:ChangeEmailForm.tsx');*/
import Button from '../../components/Button/Button';

const validate = values => {
	const errors = {};
	const requiredFields = [ 'confirm_password', 'new_password', 'old_password' ];
	requiredFields.forEach(field => {
		if (!values[field]) { errors[ field ] = 'Required'; }
	});

	if (values.confirm_password !== values.new_password) { errors['confirm_password'] = 'Passwords must match'; }
	//if (values.password && values.password.length < 8) { errors['password'] = 'Minimum of 8 characters'; }
	return errors;
}

import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { TextField } from '../../components/fields';
export default reduxForm({form: 'ChangePasswordForm'})(({ handleSubmit, changePassword, submitting, pristine, reset, cancel }) => {
  const submit = (values) =>
		changePassword({new_password: values['new_password']})
			.then(cancelHandler)
			.catch((args) => {
				const [payload, initialPayload, resp] = args;
				const errors = get(resp, 'xhr.response.errors');
				const _error = get(resp, 'xhr.response.non_field_errors.0');
				if (_error || !isEmpty(errors)) throw new SubmissionError({...errors, _error});
			})

    const cancelHandler = (...args) => {
        cancel();
        return reset(...args);
    };
    return (
      <form onSubmit={handleSubmit(submit)}>
            <Field name='old_password' type='password' component={TextField} label='Current Password' placeholder="Your current Password" />
            <Field name='new_password' type='password' component={TextField} label='New Password' placeholder="Your New Password" />
            <Field name='confirm_password' type='password' component={TextField} label='Confirm New Password' placeholder="Your password" />
            <div>
                <Button type="button" kind="secondary" disabled={submitting} onClick={cancelHandler}>Cancel</Button>
                <Button type="submit" disabled={pristine || submitting}>Submit</Button>
            </div>
        </form>
    );
});



// WEBPACK FOOTER //
// ./src/app/containers/Account/ChangePasswordForm.tsx